import { useQuery, type UseQueryOptions } from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { payoutsKeys } from "../payouts.utils"
import type { ResponseDto, PayoutDto, QueryParamsDto } from "@mimber/schema"

/**
 * Get historical payouts with pagination, filtering, and sorting
 * GET /organization/payouts
 */
export const usePayouts = (
  params?: QueryParamsDto,
  options?: Partial<UseQueryOptions<ResponseDto<PayoutDto[]>, Error>>
) => {
  guardAppUsage("mimber-organization", "usePayouts")

  const { server } = useServerContext()

  return useQuery<ResponseDto<PayoutDto[]>, Error>({
    queryKey: payoutsKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get("/organization/payouts", { params })
      return response.data
    },
    ...options,
  })
}
